import React from "react";
import { Change, Variant } from "@bloomberg/media-ui-markets";
import styles from "./holdingsDrawer.module.css";
import { formatWithCommasAndDecimals } from "~utils/portfolio/formatNumber";

export type DrawerTickerHeaderProps = {
  readonly price: number | null;
  readonly currency: string;
  readonly percentChange: number | null;
};

export default function DrawerTickerHeader({
  price,
  currency,
  percentChange,
}: DrawerTickerHeaderProps) {
  if (price === null) {
    return <span>—</span>;
  }

  return (
    <div className={styles.priceRow}>
      <span>
        <span>{formatWithCommasAndDecimals(price)}</span>{" "}
        <span>{currency}</span>
      </span>
      <Change
        percentChange={percentChange ?? 0}
        variant={Variant.refresh2024}
      />
    </div>
  );
}
